import React from 'react';

import cx from 'classnames';

import styles from './Switch.scss';

export type SwitchProps = {
  label?: string | JSX.Element;
  hint?: string | JSX.Element;
  id?: string;
  name: string;
  checked?: boolean;
  className?: string;
  onChange?(
    event: React.FormEvent<HTMLInputElement>,
    newChecked: boolean,
    name: string,
  ): void;
  onBlur?(event: React.FocusEvent): void;
  disabled?: boolean;
};

export const Switch: React.FunctionComponent<SwitchProps> = ({
  label,
  hint,
  className,
  ...props
}) => {
  const onChange = (event: React.FormEvent<HTMLInputElement>) => {
    const { name, checked: newChecked } = event.currentTarget;
    if (props.onChange) props.onChange(event, newChecked, name);
  };

  return (
    <div className="jg-display-flex jg-flex-ais jg-flex-jcb jg-space-mbmd">
      <label className={styles.label} htmlFor={props.id || props.name}>
        {label}
        {hint && <div className={cx('jg-space-mtxs', styles.hint)}>{hint}</div>}
      </label>
      <div className="jg-space-mbmd jg-space-mlml">
        <input
          id={props.id || props.name}
          type="checkbox"
          className={cx('jg-form-control', styles.input, className)}
          {...props}
          /* this onChange overwrite props.onChange */
          onChange={onChange}
        />
        <label htmlFor={props.id || props.name} aria-hidden="true" />
      </div>
    </div>
  );
};

export default Switch;
